<script>
import ConsultingForm from '@/components/ConsultingForm';
import OverlayPageLink from '@/components/OverlayPageLink';

export default {
  name: 'ContentConsultingFormBlock',
  components: {
    ConsultingForm,
    OverlayPageLink
  },
  props: {
    data: Object
  },
  data() {
    return {
      errors: [],
      sendError: false,
      formData: {},
      isSaving: false
    };
  },
};
</script>

<template>
  <section class="consulting-form-block">
    <div class="consulting-form-block__anchor" v-bind:id="data.anchor"></div>
    <div class="richtext">
      <h2 class="consulting-form-block__title section-title">{{ data.label }}</h2>
      <p class="consulting-form-block__lead">{{ data.lead }}</p>
    </div>

    <div class="consulting-form-block__notice">
      <overlay-page-link
        v-bind:type="'read-more'"
        v-bind:label="data.notice_label"
        v-bind:page="data.notice_link"
      ></overlay-page-link>
    </div>

    <div class="consulting-form-block__form">
      <consulting-form v-bind:data="data" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.consulting-form-block {
  margin-top: 12.8rem;
}

.consulting-form-block__anchor {
  position: relative;
  top: -12.8rem;

  @include breakpoint('xs-down') {
    top: -8.8rem;
  }
}

.consulting-form-block__title {
  margin-top: 0;
}

.consulting-form-block__actions {
  margin-top: 6rem;
}

.consulting-form-block__form {
  margin-top: 5.6rem;
}

.consulting-form-block__error-title {
  margin-bottom: 4rem;
  font-weight: 300;
  color: $color-danger;
}
</style>
